



























































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import {
  IWorkOrderCard,
  IStaff,
  UserRoles,
  ROLES_LIST,
  IRoleItem
} from "@/interfaces";
import { formatDate } from "@/utils";
import { LeftVoiceMail } from "@/api";

@Component({
})
export default class RimRepairCardComponent extends Vue {
  @Prop({ required: true }) workOrder!: IWorkOrderCard;
  @Prop({ required: true }) staff!: IStaff[];

	private updating: boolean = false;

	private async LeftVoiceMail()
	{
        this.updating = true;

        const resp = await LeftVoiceMail(this.workOrder.RecordID,this.workOrder.LVM);

        this.updating = false;
        
				if (!resp.Ok) {
          // this.setSnackbarAction({
          //   message: `Work order transferred successfully`,
          //   status: "success",
          // });
          // this.$emit("close-succes");
        }


		console.log('ok');
	}

	get ServicesDoneArray(): string[]{
		return this.GetArrr(this.workOrder.ServicesDone);
	}

	get ServicesTodoArray(): string[]{
		return this.GetArrr(this.workOrder.ServicesToDo);
	}

	private GetArrr(std:string): string[]
	{
		if (std == null || std == undefined || std == '' )return [];
		var rval = std.split(',');
		return rval;
	}

  get backgroundColor() {
		let color = "";
		if (this.workOrder.IsCompleted){
			return "grey darken-4";
		}

    if (this.workOrder.TransferStatus === 7) {
      color = "green darken-4";
    } else if (this.workOrder.TransferStatus === 13) {
      color = "red";
    } else if (this.workOrder.TransferStatus === 1) {
      color = "yellow darken-3";
    }
    return color;
  }

  get userNameFrom() {
    return this.getName(this.workOrder.SentBy!);
  }

  get userNameTo() {
    return this.getName(this.workOrder.SentTo!);
  }

  get customerName() {

		var n = this.workOrder.CustName;
		return n;  
  }

  get car() {
    return `${this.workOrder.Make} ${this.workOrder.Model} ${this.workOrder.Year} `;
	}
	
	get orderStatus(): string{
    let status = "";
    if (this.workOrder.TransferStatus === 7) {
      status = "Success";
    } else if (this.workOrder.TransferStatus === 13) {
      status = "Error";
    } else if (this.workOrder.TransferStatus === 1) {
      status = "Handle";
    }
    return status;
	}

  getName(id: number) {
		if (!id)return "Unknown";
    const user: IStaff | undefined = this.staff.find(s => s.RecordID === id);
		if (user==null)return "User not found "+id;
		return user!.FName + " " + `(${this.formatRoles(user!.Roles)})`;
  }

  formatRoles(roles: UserRoles[]) {
    let rol = "";
    roles.forEach(
      r => (rol += !rol ? this.roleName(r) : `, ${this.roleName(r)}`)
    );
    return rol;
  }

  roleName(rol: UserRoles) {
    const r: IRoleItem | undefined = ROLES_LIST.find(s => s.value === rol);
    return r!.text;
  }

  formatDate(date: string) {
    return formatDate(date, "dd-MM-yyyy");
  }
}


